// Rendering parameters
export const FRAME_RATE = 20;
export var AbortReason;
(function (AbortReason) {
    AbortReason["Close"] = "close";
})(AbortReason || (AbortReason = {}));
export const PLAY_VIDEO_TIMEOUT = 6000;
